const states_one = require('./variant_one');
const states_two = require('./variant_two');
const states_three = require('./variant_three');

// Static variants (fallback)
const staticVariants = [null, null, null];

staticVariants[0] = {
    metersVisibleAfter: 9,
    fifthMeterVisibleAfter: 9,
    phonebookVisibleAfter: 0,
    states: states_one.states_one,
    min: [-10, -7, -9, -4, -5],
    max: [9, 4, 3, 4, 4],
};
staticVariants[1] = {
    metersVisibleAfter: 9,
    fifthMeterVisibleAfter: 9,
    phonebookVisibleAfter: 0,
    states: states_two.states_two,
    min: [-14, -8, -11, -7, -8],
    max: [12, 5, 5, 2, 5],
};
staticVariants[2] = {
    metersVisibleAfter: 9,
    fifthMeterVisibleAfter: 9,
    phonebookVisibleAfter: 0,
    states: states_three.states_three,
    min: [-20, -10, -14, -9, -10],
    max: [18, 4, 5, 2, 4],
};

// Dynamic variants cache
let dynamicVariants = null;
let dynamicLoadAttempted = false;
let dynamicLoadTime = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

/**
 * Load dynamic variants from the backend API.
 * This module is used by the browser, so we fetch the active scenario from the API.
 */
async function loadDynamicVariants() {
    // Check if we should reload (cache expired)
    if (dynamicVariants && dynamicLoadTime && 
        (Date.now() - dynamicLoadTime < CACHE_DURATION)) {
        return dynamicVariants;
    }

    try {
        const response = await fetch('/api/scenarios/active/gametree');
        if (response.ok) {
            const result = await response.json();
            const data = result.data;

            if (data && data.variants) {
                dynamicVariants = data.variants;
                dynamicLoadTime = Date.now();
                console.log('Loaded dynamic scenario:', data.scenarioName);
                return dynamicVariants;
            }
        }
    } catch (err) {
        console.warn('Failed to load dynamic variants:', err.message);
    }

    // Mark that we attempted to load
    dynamicLoadAttempted = true;
    return null;
}

/**
 * Clear dynamic cache (for testing)
 */
function clearDynamicCache() {
    dynamicVariants = null;
    dynamicLoadAttempted = false;
    dynamicLoadTime = null;
}

module.exports = {
    getVariant(variant) {
        var ix = variant || 0;
        if (ix < 0 || ix >= 3) {
            ix = 0;
        }

        // Return dynamic variant if available
        if (dynamicVariants && dynamicVariants[ix]) {
            return dynamicVariants[ix];
        }

        // Fallback to static variant
        return staticVariants[ix];
    },

    /**
     * Async version of getVariant that ensures dynamic loading
     */
    async getVariantAsync(variant) {
        var ix = variant || 0;
        if (ix < 0 || ix >= 3) {
            ix = 0;
        }

        // Try to load dynamic variants if not already loaded
        if (!dynamicLoadAttempted || !dynamicVariants) {
            await loadDynamicVariants();
        }

        // Return dynamic variant if available
        if (dynamicVariants && dynamicVariants[ix]) {
            return dynamicVariants[ix];
        }

        // Fallback to static variant
        return staticVariants[ix];
    },

    /**
     * Initialize dynamic loading (call this at app startup)
     */
    async initializeDynamicLoading() {
        try {
            await loadDynamicVariants();
        } catch (err) {
            console.warn('Failed to initialize dynamic loading:', err.message);
        }
    },

    /**
     * Clear dynamic cache
     */
    clearDynamicCache: clearDynamicCache,
    progressStates(variant) {
        return this.getVariant(variant).states;
    },
    /**
     * Finds the progress of a dilemma in a given variant.
     *
     * @param {type} variant - the game variant to search in
     * @param {type} dilemmaId - the ID of the dilemma to find the progress of
     * @return {type} the index of the dilemma in the variant, or -1 if not found
     */
    findDilemmaProgress(variant, dilemmaId) {
        const states = this.getVariant(variant).states;
        // Find index of dilemmaId in states
        const progress = states.findIndex((e) => {
            return e.dilemmaId == dilemmaId;
        });
        //console.log(`findDilemmaProgress(${variant}, ${dilemmaId}): ${progress}`);
        return progress;
    },
    findDilemma(variant, dilemmaId) {
        const states = this.getVariant(variant).states;
        // Find index of dilemmaId in states
        const progress = states.findIndex((e) => {
            return e.dilemmaId == dilemmaId;
        });
        return states[progress];
    },
    findNextDilemma(variant, dilemmaId) {
        const states = this.getVariant(variant).states;
        const currentIndex = this.findDilemmaProgress(variant, dilemmaId);
        if (currentIndex < states.length - 1) {
            return states[currentIndex + 1];
        } else {
            console.log('No next dilemma');
            return states[currentIndex];
        }
    },
    getDilemmaId(variant, progress) {
        const state = this.getVariant(variant).states[progress];
        return state.dilemmaId;
    },
    areMetersVisible(variant, progress) {
        const state = this.getVariant(variant).states[progress];
        if (!state) {
            console.log(`No state found for variant ${variant} and progress ${progress}`);
            return false;
        }
        return true; //state.areMetersVisible || false;
    },
    isFifthMeterVisible(variant, progress) {
        // TODO determine when this meter is visible
        return this.areMetersVisible(variant, progress); // progress >= this.getVariant(variant).fifthMeterVisibleAfter;
    },
    // isPhonebookVisible(variant, progress) {
    //     return progress > this.getVariant(variant).phonebookVisibleAfter;
    // },
    // isHacked(variant, progress) {
    //     return false; // progress >= 12;
    // },
    isFinished(variant, progress) {
        return progress >= this.getVariant(variant).states.length;
    },
    isLogoutVisible() {
        return true;
    }
    // etc.
};
